import type { Dayjs } from 'dayjs'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { ClientBookingSubscriptionStatusMessage } from '@/src/domains/client-booking/components/ClientBookingSubscriptionStatus/ClientBookingSubscriptionStatusMessage'

import { useClientBookingSubscriptionStatusLegacy } from './useClientBookingSubscriptionStatusLegacy'

export interface ClientBookingSubscriptionStatusLegacyProps {
  month: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const ClientBookingSubscriptionStatusLegacy = ({
  month,
  therapist,
  service,
}: ClientBookingSubscriptionStatusLegacyProps) => {
  const message = useClientBookingSubscriptionStatusLegacy({ month, therapist, service })

  if (!message) {
    return null
  }

  return <ClientBookingSubscriptionStatusMessage {...message} />
}
